import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, } from '@fortawesome/free-solid-svg-icons'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class Yellowsix extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"> <Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active">Six Sigma Yellow Belt Program </li>
                    </ol>
                </div>
                <section class="course-header bg-yellow11" id="course-header" >
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5" style={{// eslint-disable-next-line
                            backgroundImage: "url(" + "/assets/images/icons/six-sigma-bkg/six-sigma-symbol.svg" + ")",
                        }}>
                            <h1>Six Sigma Yellow Belt <br />Program</h1>
                            <br />
                            <br />
                            <br />
                            <div class="form-group">
                                <a href="#apply-nows" class="btn btn-md enroll-btn" >Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/six-sigma-yellow-belt-program');">Download
                        brochure</button>
                            </div><br /> <br /><h3> Online Live Training</h3><br /> <br />
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <p>Certification jointly awarded by</p>
                            <ul>
                                <li><img alt="executive" width="" src="/assets/images/isi.svg" />  </li>
                                <li><img alt="executive" width="" src="/assets/images/epn.svg" /></li>
                            </ul>
                            <br />
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z" id="Description">
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6">
                                <b>Schedule: </b><br />
                            </div>
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6" >
                                <b> <i class="fa fa-calendar" ></i>&nbsp; Upto 2 Days</b><br />
                                <b>(Customisable as per requirements)</b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Curriculum">Program Curriculum</a></li>
                            <li><a href="#course-description">Eligibility</a></li>
                            <li><a href="#Schedule">Course Schedule</a></li>
                            <li><a href="#Review-s">Learner Review </a></li>
                            <li><a href="#Certification-s">Certification</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-nows">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <section class="course-description " id="course-description">
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Program Overview</h3>
                            <p align="justify">The participants will acquire transferable problem-solving skills and competence to solve many problems in the forthcoming years for any organisation. </p>
                        </div>
                    </div>
                    <br />
                    <div class="row owl-carousel-end">
                        <div class="col-sm-12" >
                            <h3 >Who Should Enroll?</h3><h6 > The course is designed for Certified Six Sigma Black Belts from the following areas</h6>
                            <ul class="highlight-ul ul-text row">
                                <div class="col-sm-6">
                                    <li id="Curriculum"> Top Executives</li>
                                    <li>	Middle Management</li>
                                    <li>	Engineers</li>
                                </div>
                                <div class="col-sm-6">
                                    <li>	Entrepreneurs</li>
                                    <li>	Transactional process leaders of any discipline from any type of industry</li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class="course-syllabus " id="course-syllabus">
                    <div class="row" >
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                            <h3>Program Curriculum </h3>
                            <br />
                            <div class="syl-bg">
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a><i class="indicator fa fa-minus"></i> DMAIC	 </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction	</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a><i class="indicator fa fa-minus"></i> Define	 </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Introduction,Project Charter,Voice of the Customer & CTQ Tree, Process Map</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a><i class="indicator fa fa-minus"></i> Measure </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Data Collection,Process Capability (Sigma Level) Estimation	 </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a><i class="indicator fa fa-minus"></i> Analysis</a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Process Analysis,VSM,Process Failure Mode & Effect Analysis,Test of Hypothesis</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="dv_heading5" data-toggle="collapse"
                                                href="#dv_syllabus5" aria-expanded="true" aria-controls="dv_syllabus5">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a><i class="indicator fa fa-minus"></i> Improvement	</a>
                                                </h6>
                                            </div>
                                            <div id="dv_syllabus5" class="collapse show" aria-labelledby="dv_heading5"
                                                data-parent="#dv_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Generate, Evaluate & Select Solutions, Piloting	</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="dv_heading6" data-toggle="collapse"
                                                href="#dv_syllabus6" aria-expanded="true" aria-controls="dv_syllabus6">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }  <a><i class="indicator fa fa-minus" id="Schedule"></i> Control</a>
                                                </h6>
                                            </div>
                                            <div id="dv_syllabus6" class="collapse show" aria-labelledby="dv_heading6"
                                                data-parent="#dv_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Control Charts, Control Plan, Basic Seven Tools	</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section class="course-learning-outcome bg-secondary1 " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3> Exam and Certification</h3>
                            <br />
                            <ul>
                                <li>Each participant must score at least 60% in the examination administered on the second day of the program.  </li>
                                <br />
                                <li>Upon passing the examination, the participant will be provided with Six Sigma Yellow-Belt Certificate.
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img alt="datascience18" src="/assets/images/icons/certificate-final.png" />
                            <p class="img-below-text text-center" id="apply-nows"><br />Awarded Jointly by The Indian Statistical Institute,<br />Pune and
                    edu plus now </p>
                        </div>
                    </div>
                    <br /><br />
                </section>
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li>  Indian Statistical Institute, Pune as a knowledge partner. </li>

                                            <li> Mentorship by industry specialists.</li>
                                            <li>  Seamless EMI options.  </li>
                                            <li>  Industry-oriented curriculum. </li>
                                            <li> Course awarded by Edu Plus Now and Indian Statistical Institute, Pune.</li>
                                        </ul>
                                    </div>
                                    <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About the Organization</h3>
                            <br />
                            <img alt="isi" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                                 </p>
                            <br />
                            <p align="justify">ISI Pune is a unit of Indian Statistical Institute, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                                     Data Analytic, Data Science. </p>
                        </div>
                    </div>
                </section>
                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header" >
                                <span class="close" id="close_form" data-dismiss="modal">&times;</span>
                                <br />
                            </div>
                            <div class="modal-body" >
                                <div class="panel panel-default paper-shadow box_detail">
                                    <h5 class="text-center "> Download The Course Brochure </h5>
                                    <form method="post" class="form-row" onsubmit="return validate()">

                                        <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                            required="" autocomplete="on" name="name" id="name" />
                                        <b>Your email</b><input class="form-control" type="email" required=""
                                            autocomplete="on" name="emaill" id="emaill" />
                                        <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                            type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                        <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                        <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                        <br />
                                        <div>
                                            <div class="form-group">
                                                <div id="recaptcha" class="g-recaptcha"
                                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                                <div id="captcha"></div>
                                            </div>
                                        </div>
                                        <div class="mob_cb" >
                                            <div>
                                            </div><br />
                                            <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)" id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                        <br />
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default Yellowsix;